module.exports = __webpack_public_path__ + "static/media/youtube.e5b5d0e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/youtube.svg
// module id = 315
// module chunks = 0